import React, { useState, useEffect } from "react";
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from "primereact/inputtext";
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { Dialog } from "primereact/dialog";
import { Dropdown } from 'primereact/dropdown';
import { ValidateAdminRole } from '../../../helper/validateRole';
import { Auth } from 'aws-amplify';
import Layout from "../../../components/common/nav/admin/nav.component";
import { Link } from "react-router-dom";
import { Image } from "primereact/image";
import sidebar from "../../../assets/images/sidebarright.svg"
import { USER_TYPES_NAMES, USER_TYPES, USER_TYPE_CODE, USER_TYPE_LIST } from "../../../helper/enum";
import DataTables from "react-data-table-component";
import { DataTableCustomStyles, ManageAccessCustomStyles } from "../../../helper/dataTable.config";
import awsmobile from "../../../aws-exports";
import { toast } from "react-toastify";
import AWS from "aws-sdk";
import { Groups, RoleAccess, RollAccess, UserGroups } from "../../../models";
import { DataStore, Predicates, SortDirection } from "aws-amplify";
import capitalizeFirst from "../../../components/common/capitalizeFirst";
import { MultiSelect } from 'primereact/multiselect';
import { DataTable } from "primereact/datatable";
import { Checkbox } from "primereact/checkbox";
import Login from "../../../setup/auth/login.component";

export default function Role() {

    const [isCheck, setIsCheck] = useState(null);
    const [isAuthenticated, userHasAuthenticated] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0);
    const [selectedRole, setSelectedRole] = useState(null);
    const [selectedUsers, setSelectedUsers] = useState(null);
    const [withoutAdminUserList, setWithoutAdminUserList] = useState([]);
    const roleList = [
        { name: "Initiator", code: "I" },
        { name: "Approver", code: "AP" },
        { name: "Payroll", code: "P" }
    ]
    let [userList, setUserList] = useState([]);

    // for (let i = 0; i < withoutAdminUserList.length; i++) {
    //     if (withoutAdminUserList[i].role !== 'AP') {
    //         continue;
    //     } else {
    //         userList.push(withoutAdminUserList[i]);
    //     }
    // }

    const changeRole = (e) => {
        setSelectedRole(e.value);

        let newList = [];
        for (let i = 0; i < withoutAdminUserList.length; i++) {
            if (withoutAdminUserList[i].role !== e.value.code) {
                continue;
            }
            else {
                newList.push(withoutAdminUserList[i]);
            }
        }
        setUserList(newList);
    }

    const onSelectUser = (e) => {
        setSelectedUsers(e.value);
    }



    //SET AWS Configuration
    AWS.config.update({
        accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
        secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
        region: process.env.REACT_APP_AWS_Region,
    });

    const [visibleRight, setVisibleRight] = useState(false);
    const [visibleRight1, setVisibleRight1] = useState(0);
    const [visibleRight2, setVisibleRight2] = useState(false);
    const [visibleRight3, setVisibleRight3] = useState(false);
    const [selectedCity, setSelectedCity] = useState(null);
    const [selecteRoll, setSelectedRoll] = useState();
    const [pageList, SetPageList] = useState();
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [users, SetUsersList] = useState([]);
    const [filterUsers, SetFilterUsersList] = useState([]);
    const [usersOfRoles, SetUsersOfRoles] = useState([]);
    const [groupList, SetGroupList] = useState([]);
    const [groupName, setGroupName] = useState('');


    const goBack = () => {
        // setPleaseWaitButton(false);
        // navigateTo("/admin/setting/masters/school");
        setVisibleRight3(false);
    }

    //Create Group Info
    const saveGroupInfo = async () => {

        if (groupName === '') { toast.error('Please enter Group Name'); return; }

        var updatedSchoolId;
        {
            //Save Group Info
            var newSchoolId = await DataStore.save(new Groups({
                "name": capitalizeFirst(groupName),
                assigned_members_count: (selectedUsers != null) ? selectedUsers.length : 0,
            })
            );

            if (newSchoolId) {
                updatedSchoolId = newSchoolId.id;

                //Save User Groups info
                if (selectedUsers != null || selectedUsers.length > 0) {
                    try {
                        for (let i = 0; i <= selectedUsers.length; i++) {
                            let selectedUserId = selectedUsers[i].userId;
                            const post = await DataStore.save(
                                new UserGroups({
                                    user_id: selectedUserId,
                                    group_id: updatedSchoolId,
                                    lock_access: false,
                                    request_type: "request_type",
                                })
                            );
                        }

                    } catch (error) {
                        console.log('Error saving post', error);
                    }
                }

            }
            toast.success('Group Added Successfully.');
            goBack()
        }
    }




    function handleActionClick(row) {
        SetUsersOfRoles(row.users)
        setVisibleRight2(true);
    }


    //*Column Name
    const DataTableColumns = [
        {
            name: "Role",
            selector: row => row.role,
            sortable: true,
        },
        {
            name: "Users",
            selector: row => row.count,
            sortable: true,
        },
        {
            name: 'Lock  Access',
            selector: row => <> <input type="checkbox" /></>,
            sortable: true,
        },
        {
            name: 'Action',
            selector: row => <div className="flex justify-start w-full gap-2 pr-[4vw]">
                <Link to='#' className="py-2 px-5 bg-[#fff] text-[#344054] text-sm border border-[#D0D5DD] rounded-lg shadow-[0px_1px_2px_rgba(16,24,40,0.05)]"

                    // onClick={() => setVisibleRight2(true)}
                    onClick={() => handleActionClick(row)}

                >Manage Members</Link>
            </div>,
            sortable: true,
            ignoreRowClick: true,
            allowOverflow: true,
            center: true,
            button: true,
        },



    ];

    // Manage Member pop up
    const manageMemberPopUpData = [
        {
            name: "User Name",
            selector: row => row.name,
            sortable: true,
        },
        {
            name: "User Email",
            selector: row => row.email,
            sortable: true,
        },
        {
            name: "User Code",
            selector: row => row.usercode,
            sortable: true,
        },
        {
            name: 'Lock  Access',
            selector: row => <> <input type="checkbox" /></>,
            sortable: true,
        },

    ];

    // Manage Access Data Columns
    const manageAccessTableColumns = [
        {
            name: "Role",
            selector: row => row.role,
            sortable: true,

        },
        {
            name: "Users",
            selector: row => row.count,
            sortable: true,
        },
        {
            name: 'Lock  Access',
            selector: row => <> <input type="checkbox" /></>,
            sortable: true,
        },
        {
            name: 'Action',
            selector: row => <div className="flex justify-start w-full gap-2 pr-[4vw]"
                onClick={() => setVisibleRight1(1)} >
                <Link to='#' className="py-2 px-5 bg-[#fff] text-[#344054] text-sm border border-[#D0D5DD] rounded-lg shadow-[0px_1px_2px_rgba(16,24,40,0.05)]">Manage Access</Link>
            </div>,
            sortable: true,
            ignoreRowClick: true,
            allowOverflow: true,
            center: true,
            button: true,
        },
    ];

    // Page List Colunms 
    const pageListTableColumns = [
        {
            name: "Modals",
            selector: row => row.name,
            sortable: true,

        },
        {
            name: "View",
            selector: row => <> <input type="checkbox" /></>,
            sortable: true,
        },
        {
            name: 'Add',
            selector: row => <> <input type="checkbox" /></>,
            sortable: true,
        },
        {
            name: 'Edit',
            selector: row => <> <input type="checkbox" /></>,
            sortable: true,
        },
        {
            name: 'Delete',
            selector: row => <> <input type="checkbox" /></>,
            sortable: true,
        },




    ];


    async function LoadUsers() {

        try {
            const cognito = new AWS.CognitoIdentityServiceProvider();


            var params =
            {
                UserPoolId: awsmobile.aws_user_pools_id,
                Limit: 60
            };


            cognito.listUsers(params, (err, data) => {
                if (err) {
                    console.log(err);
                    toast.error(err.message);
                } else {

                    const roles = [];
                    var newRes = []
                    var role = "";
                    var name = "";
                    var email = "";
                    var usercode = "";
                    var sub = "";
                    let withoutAdminUsers = [];

                    data.Users.forEach((user, i) => {
                        sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
                        role = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
                        name = user.Attributes.find(attr => attr.Name === "name")?.Value;
                        email = user.Attributes.find(attr => attr.Name === "email")?.Value;
                        usercode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
                        let newUser = {
                            "userId": sub,
                            "name": name,
                            "email": email,
                            "usercode": usercode,
                            "role": role === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : role === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : role === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
                        }
                        newRes.push(newUser);

                        if (i === data.Users.length - 1) {

                            for (let i = 0; i < newRes.length; i++) {
                                const user = newRes[i];
                                const roleIndex = roles.findIndex(role => role.role === user.role);


                                if (roleIndex === -1) {
                                    roles.push({ role: user.role, count: 1, users: [user], email: user.email, name: user.name, usercode: user.usercode });
                                } else {
                                    roles[roleIndex].count++;
                                    roles[roleIndex].users.push(user);
                                }
                            }
                        }

                        //fetch those user who are not admin.
                        if (role !== USER_TYPES.ADMIN) {
                            let userObj = {
                                "userId": sub,
                                "name": name,
                                "email": email,
                                "usercode": usercode,
                                "role": role
                            }
                            withoutAdminUsers.push(userObj);
                        }
                    });
                    SetUsersList(roles);
                    SetFilterUsersList(roles)
                    setWithoutAdminUserList(withoutAdminUsers);
                }
            });

        } catch (e) {
            toast.error(e.message);
        }

    }


    const groupLockAccess = async (row) => {

        let isLockAccess = !row.is_access_locked;

        const originalGroup = await DataStore.query(Groups, row.id);

        const originalGroupUsers = await DataStore.query(UserGroups, (c) => c.group_id.eq(row.id));

        await DataStore.save(Groups.copyOf(originalGroup, updated => { updated.is_access_locked = isLockAccess }));

        if (originalGroupUsers) {
            for (let i = 0; i <= originalGroupUsers.length; i++) {
                await DataStore.save(UserGroups.copyOf(originalGroupUsers[i], updated => { updated.lock_access = isLockAccess; }));
                if (i === originalGroupUsers.length - 1) {
                    BindList()
                }
            }
        }

        setIsCheck(isLockAccess);
    }

    const groupDataTableColumns = [

        {
            name: "Group Name",
            selector: row => row.name,
            sortable: true,
        },

        {
            name: 'Assighned Members',
            selector: row => row.assigned_members_count,
            sortable: true,
        },
        {
            name: 'Lock  Access',
            selector: row => row.is_access_locked,
            cell: (row) => (<input type="checkbox" checked={row.is_access_locked} onChange={() => groupLockAccess(row)} />),
        },
        {
            name: 'Action',
            selector: row => <div className="flex justify-start w-full gap-2 pr-8">
                <Link href='#' className="py-2 px-5 bg-[#fff] text-[#344054] text-sm border border-[#D0D5DD] rounded-lg shadow-[0px_1px_2px_rgba(16,24,40,0.05)]" >View Groups</Link>
            </div>,
            sortable: true,
            ignoreRowClick: true,
            allowOverflow: true,
            center: true,
            button: true,
        },
    ];

    //Search Roll
    const searchRoll = (searchedText) => {
        if (searchedText.length > 1) {
            let data = [...filterUsers]
            let filteredData = data.filter(e =>
                e.role.toLowerCase().includes(searchedText.toLowerCase())
            )
            SetUsersList(filteredData)
        } else {
            let data = [...filterUsers]
            SetUsersList(data)
        }
    }

    //Get School List
    const BindList = async () => {
        //Set Group List
        var groupResponses = await DataStore.query(Groups, Predicates.ALL, {
            sort: s => s.name(SortDirection.ASCENDING)
        });
        SetGroupList(groupResponses)

        //Set Pages List In Manage Access
        var pagesResponses = await DataStore.query(RoleAccess, Predicates.ALL, {
            sort: s => s.name(SortDirection.ASCENDING)
        });
        SetPageList(pagesResponses)

    }

    async function onLoad() {
        try {
           await Auth.currentSession();
           if (!ValidateAdminRole()) { userHasAuthenticated(false); }
        } catch (e) {
           console.log("error-->", e)
           userHasAuthenticated(false);
        }
     }

    useEffect(() => {
        onLoad()
        BindList()
        LoadUsers();
    }, [isCheck]);


    return isAuthenticated ?  (
        <>
            <Layout pageTitle="Users Management">
                <div className="pt-10">
                    <div className="roletabs relative">
                        <div className="flex items-center gap-4 justify-end absolute z-10 right-0 py-1">
                            <div className="xl:w-[15.058vw] md:w-[200px]">
                                <span className="w-full p-input-icon-left">
                                    <i className="gusd-search text-[#667085] top-3" />
                                    <InputText onChange={(e) => searchRoll(e.target.value)} placeholder="Search" className="w-full placeholder:text-[#667085] radius8" />
                                </span>
                            </div>
                            {
                                (activeIndex === 0) ?
                                    <Link to='' className="w-auto text-center tableBtn blue radius8" onClick={() => setVisibleRight3(true)}>Create Role</Link>
                                    : (activeIndex == 2) ?
                                        <Link to='' className="w-auto text-center mt-2 tableBtn blue radius8" onClick={() => setVisibleRight3(true)}>Create Group</Link>
                                        : null
                            }
                        </div>
                        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                            <TabPanel header="Roles">
                                <div className="flex gap-2 py-5 px-4 items-center">
                                    <div className="text-[#101828] font-medium text-lg">Roles</div>
                                    <Tag severity="" value={`${USER_TYPE_LIST.length} Roles`} style={{ background: '#EFF8FF', color: '#0487C8', fontSize: 11, fontWeight: 500, padding: '0px 15px', height: 20 }} rounded></Tag>
                                </div>
                                <div className="roletbl">
                                    {
                                        <DataTables
                                            columns={DataTableColumns}
                                            data={users}
                                            customStyles={DataTableCustomStyles}
                                            pagination
                                            highlightOnHover
                                        />
                                    }
                                </div>
                            </TabPanel>
                            <TabPanel header="Role Access">
                                <div className="flex gap-2 py-5 px-4">
                                    <div className="text-[#101828] font-medium text-lg">Manage Access</div>
                                    <Tag severity="" value={`${USER_TYPE_LIST.length} Roles`} style={{ background: '#EFF8FF', color: '#0487C8' }} rounded></Tag>
                                </div>
                                <div className="roletbl">
                                    {
                                        <DataTables
                                            columns={manageAccessTableColumns}
                                            data={users}
                                            customStyles={DataTableCustomStyles}
                                            pagination
                                            highlightOnHover
                                        />
                                    }
                                </div>
                            </TabPanel>
                            <TabPanel header="Groups">
                                <div className="flex gap-2 py-5 px-4">
                                    <div className="text-[#101828] font-medium text-lg">Groups</div>

                                    <Tag severity="" value={`${groupList.length} Groups`} style={{ background: '#EFF8FF', color: '#0487C8', fontSize: 11, fontWeight: 500, paddingTop: "16px", height: 20 }} rounded></Tag>
                                </div>
                                <div className="roletbl">
                                    {
                                        <DataTables
                                            columns={groupDataTableColumns}
                                            data={groupList}
                                            customStyles={DataTableCustomStyles}
                                            pagination
                                            highlightOnHover
                                        />
                                    }
                                </div>
                            </TabPanel>
                        </TabView>

                        <Dialog className="relative reports-popup" visible={visibleRight1} position="right" style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisibleRight2(false)} draggable={false} resizable={false}>
                            <div className="">
                                <div className="bg-[#F5F6F7] h-screen">
                                    <div className="p-5">
                                        <Link href='' onClick={() => setVisibleRight1(0)} className="py-3">
                                            <Image src={sidebar} alt="user" width="24" height="24" /></Link>
                                        <div className="flex justify-between items-center">
                                            <div>
                                                <div className="text-[#113699] mt-2 text-md md:text-[0.833vw] font-bold">Manage Members</div>
                                                <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Roles</div>
                                            </div>
                                            <div className="select-styling">
                                                <Dropdown value={selecteRoll} onChange={(e) => setSelectedRoll(e.value)} options={USER_TYPE_CODE} optionLabel="name" placeholder="Initiator" className="w-full" />
                                            </div>
                                        </div>

                                        <div className="py-3 roletbl mt-2">
                                            {
                                                <DataTables
                                                    columns={pageListTableColumns}
                                                    data={pageList}
                                                    customStyles={ManageAccessCustomStyles}
                                                    pagination
                                                    highlightOnHover
                                                />
                                            }
                                        </div>
                                    </div>
                                    <div className="absolute right-5 bottom-5 flex justify-end gap-2">
                                        <Link href='' className="w-20 text-center flex items-center tableBtn blue radius8">Save</Link>
                                    </div>
                                </div>
                            </div>

                        </Dialog>


                        <Dialog className="relative reports-popup" visible={visibleRight2} position="right" style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisibleRight2(false)} draggable={false} resizable={false}>
                            <div className="">
                                <div className="bg-[#F5F6F7] h-screen">
                                    <div className="p-5">
                                        <Link to='' onClick={() => setVisibleRight2(false)} className="py-3"><Image
                                            src={sidebar} alt="user" width="24" height="24" /></Link>
                                        <div className="flex justify-between items-center">
                                            <div>
                                                <div className="text-[#113699] mt-2 text-md md:text-[0.833vw] font-bold">Manage Members</div>
                                                <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Roles</div>
                                            </div>
                                        </div>

                                        <div className="py-3 roletbl mt-2">
                                            {
                                                <DataTables
                                                    columns={manageMemberPopUpData}
                                                    data={usersOfRoles}
                                                    customStyles={DataTableCustomStyles}
                                                    pagination
                                                    highlightOnHover
                                                />
                                            }
                                        </div>
                                    </div>
                                    <div className="absolute right-5 bottom-5 flex justify-end gap-2">
                                        <Link to='' className="w-20 text-center flex items-center tableBtn blue radius8">Save</Link>
                                    </div>
                                </div>
                            </div>

                        </Dialog>

                        <Dialog className="relative reports-popup" visible={visibleRight3} position="right" style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisibleRight3(false)} draggable={false} resizable={false}>
                            <div className="">
                                <div className="bg-[#F5F6F7] h-screen">
                                    <div className="p-5">
                                        <Link to='' onClick={() => setVisibleRight3(false)} className="py-3"><Image
                                            src={sidebar} alt="user" width="24" height="24" /></Link>
                                        <div className="text-[#113699] mt-2 text-md md:text-[0.833vw] font-bold">Create Role</div>
                                        <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Roles</div>
                                        <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                                            <div className="mb-1">
                                                <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="username">Name</label>
                                                <div><InputText
                                                    value={groupName}
                                                    onChange={e => setGroupName(e.target.value)}
                                                    id="username" placeholder="Type Here" className="w-full placeholder:text-[#667085] " aria-describedby="username-help" /></div>
                                            </div>
                                            <div className="select-styling my-1">
                                                <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="">Role</label>
                                                <Dropdown value={selectedRole} onChange={(e) => changeRole(e)} options={roleList} optionLabel="name" placeholder="--Select Role--" className="w-full" />
                                            </div>
                                            <div className="select-styling my-1">
                                                <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="">Select User</label>
                                                {/* <Dropdown value={selectedCity} onChange={(e) => setSelectedCity(e.value)} options={options} optionLabel="name" placeholder="All" className="w-full" /> */}
                                                <MultiSelect value={selectedUsers} onChange={(e) => onSelectUser(e)} options={userList} optionLabel="name"
                                                    // display="chip"
                                                    placeholder="Select Users" maxSelectedLabels={0} className="w-full md:w-20rem" />
                                            </div>

                                            <div className="card">
                                                <DataTable
                                                    value={selectedUsers}
                                                //  tableStyle={{ minWidth: '50rem' }}
                                                >
                                                    <Column field="usercode" header="Sr.No"></Column>
                                                    <Column field="name" header="User Name"></Column>
                                                    <Column field="email" header="Email"></Column>
                                                </DataTable>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="absolute right-5 bottom-5 flex justify-end gap-2">
                                        <Link to='#' className="bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center w-20" onClick={() => setVisibleRight3(false)}>Cancel</Link>
                                        <Link to='' className="w-32 text-center flex items-center tableBtn blue radius8" onClick={() => saveGroupInfo()}>Create Group</Link>
                                    </div>
                                </div>
                            </div>
                        </Dialog>

                    </div>
                </div>
            </Layout>
        </>
      ) : (
        <Login sessionExpired={1} />
    );
}